<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Row class="sm-pc-w100">
        <Col style="text-align: left" :sm="16">
          <Form inline style="height: 41px">
            <FormItem label="需要我审批的" :label-width="90">
              <i-switch v-model="tableSearchForm.need_i_approval" @on-change="getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
          </Form>
        </Col>
        <Col style="text-align: right" :sm="8">
          <Button
            style="float: right;"
            @click="$router.push({ name: 'moduleReleaseFlowAdd' })"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add"
            class="mob-mt-f-40">申请模块</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
          <FormItem label="模块名">
            <Input v-model="tableSearchForm.name" style="min-width: 200px" />
          </FormItem>
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.applicant" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.created_at"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange" class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        stripe
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getModuleReleaseFlow, deleteModuleReleaseFlow } from '@/api/workflow/module_release_flow'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
export default {
  name: 'list',
  data () {
    return {
      tableLoading: false,
      listError: false,
      tableSearchForm: {
        name: '',
        applicant: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: false
      },
      userList: [],
      moment: moment,
      table: {
        data: [],
        columns: [
          {
            title: '申请模块名',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '项目',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '申请时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '审批完成时间',
            key: 'approve_at',
            align: 'center',
            tooltip: true,
            minWidth: 110,
            render: (h, params) => {
              if (params.row.approve_at) {
                return h('span', moment(params.row.approve_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '已通过' ? 'green' : params.row.status_verbose === '已驳回' ? 'red' : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'moduleReleaseFlowDetail', params: { id: params.row.id }, query: { lastPage: this.table.page }})
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.status === 1 && (this.$store.state.user.superuser || this.$store.state.user.userId === params.row.applicant.id) ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      }
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getAllUserData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getModuleReleaseFlow(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteModuleReleaseFlow(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: '',
        applicant: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: this.tableSearchForm.need_i_approval
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    searchApplicationTimeChange (value) {
      this.tableSearchForm.created_at_after = value[0]
      this.tableSearchForm.created_at_before = value[1]
    }
  }
}
</script>

<style scoped>
  .draw-process-btn-inactive {
    color: #999 !important;
    border-color: #999 !important;
  }
</style>
